<script>
  /**
 *
 *
 */

  /*                */
  let { totalPrice } = $props();

  const currencyFormatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  });

  const formatPrice = (price) => {
    return currencyFormatter.format(price / 100);
  };
</script>

<oc-row-v2 hide-divider>
  <div class="reco_aos_bundle_total_price__box">
    <span class="oc-copy-100 oc-copy--bold">Dein Gesamtpreis</span>
    <span class="reco_aos_bundle_total_price__price oc-copy-100 oc-copy--bold">
      {formatPrice(totalPrice)}
    </span>
  </div>
</oc-row-v2>

<style lang="scss">
  .reco_aos_bundle_total_price__box {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }

  .reco_aos_bundle_total_price__price {
    align-items: flex-end;
  }
</style>
